import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {closePopup} from './PopupSlice/popupSlice'
import {Button, Modal} from 'react-bootstrap'

const HelperMessagePopup = () => {
  const showPopup = useSelector((state: any) => state.popup.showPopup)
  const popupContent = useSelector((state: any) => state.popup.popupContent)

  const dispatch = useDispatch()

  if (!showPopup) return null

  return (
    <Modal
      show={showPopup}
      onHide={() => dispatch(closePopup())}
      dialogClassName='modal-dialog-centered'
    >
      {/* <div className='modal-header text-center row'>
        <div className='icon-box col-12'>
          <i className={`fa fa-exclamation-circle fa-2x `}></i>
        </div>
        <h2>Are you sure?</h2>
      </div> */}
      <div className='modal-body'>{popupContent}</div>
      <div className='modal-footer'>
        <Button
          color='danger'
          onClick={() => {
            dispatch(closePopup())
          }}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default HelperMessagePopup
